var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired53d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired53d"] = parcelRequire;
}
parcelRequire.register("9m8SW", function(module, exports) {

var $8p79I = parcelRequire("8p79I");

var $c01Oz = parcelRequire("c01Oz");

var $hAdDP = parcelRequire("hAdDP");
// list(1).then(list => console.log(list));
// list(2).then(list => console.log(list));
// list(3).then(list => console.log(list));
// list(4).then(list => console.log(list));
module.exports = (page)=>{
    $8p79I(page).then((list)=>{
        // primesc ca parametru list, care e o lista de 20 de obiecte
        // fiecare obiect reprezinta un film
        renderPage(list);
    });
    function renderPage(movieList) {
        let movieContainer = document.querySelector(".movies__container");
        movieContainer.innerHTML = "";
        movieList.forEach((movie)=>{
            // const htmlElement = createElementProstule(movie);
            // htmlElement.addEventListener('click', event => {
            //   modal(movie);
            //   console.log('------   Obiect Vlad    ------');
            //   console.log(movie);
            // });
            // movieContainer.appendChild(htmlElement);
            createElementProstule(movie).then((htmlElement)=>{
                htmlElement.addEventListener("click", (event)=>{
                    $hAdDP(movie);
                // console.log('------   Obiect Vlad    ------');
                // console.log(movie);
                });
                movieContainer.appendChild(htmlElement);
            });
        });
        async function createElementProstule(e) {
            const elDiv = document.createElement("div");
            elDiv.classList.add("movies__container__item");
            const moviePoster = document.createElement("img");
            moviePoster.src = `https://image.tmdb.org/t/p/w500${e.poster_path}`;
            moviePoster.classList.add("movies__container__image");
            elDiv.appendChild(moviePoster);
            const text = document.createElement("div");
            const title = document.createElement("p");
            //
            let t = "";
            if (e.title.length <= 25) t = e.title;
            else {
                let elist = e.title.split("");
                while(elist.length > 30)elist.pop();
                elist.push(".");
                elist.push(".");
                elist.push(".");
                t = elist.join("");
            }
            //
            title.innerHTML = `${t}`;
            title.classList.add("movies__container__title");
            text.appendChild(title);
            //const genreList = e.genres.map(e => e.name);
            let gen = "";
            // if (genreList.length == 1) genres += genreList[0];
            // else if (genreList.length == 2)
            //   genres += genreList[0] + ' ' + genreList[1];
            // else genres += genreList[0] + ' ' + genreList[1] + ' ' + 'other';
            //
            let genreList = await $c01Oz(); //am o lista de obiecte, unde fiecare obiect are id si nume
            let genreIds = e.genre_ids; //aici am o lista de Id-uri
            gen += createGenreString(genreList, genreIds);
            //
            gen += " | ";
            const year = e.release_date.slice(0, 4);
            gen += `${year}`;
            const subtitle = document.createElement("p");
            subtitle.innerHTML = gen;
            subtitle.classList.add("movies__container__genre");
            text.appendChild(subtitle);
            elDiv.appendChild(text);
            // console.log(genres);
            return elDiv;
        }
    }
    function createGenreString(genreList, genreIds) {
        // o sa imi fac o lista de stringuri facand match din genre id cu genre list
        // console.log('----------------');
        // console.log(genreList);
        // console.log(genreIds);
        // console.log('----------------');
        let genreStrings = [];
        let ok = false;
        for(let i = 0; i < genreIds.length; i++){
            ok = false;
            for(let j = 0; j < genreList.length && ok === false; j++)if (genreIds[i] === genreList[j].id) {
                genreStrings.push(genreList[j].name);
                ok = true;
            }
        }
        //aici voi avea in genreStrings toate genurile aferente unui film, sub forma de lista de stringuri
        //console.log(genreStrings);
        //eu vreau sa returnez un String care sa contina max 2 genuri + cuvantul other
        let ans = ""; //ans de la answer
        if (genreStrings.length === 1) ans = genreStrings[0];
        else if (genreStrings.length === 2) ans = genreStrings[0] + ", " + genreStrings[1];
        else ans = genreStrings[0] + ", " + genreStrings[1] + ", " + "other";
        return ans;
    }
};

});
parcelRequire.register("8p79I", function(module, exports) {

var $9bmoE = parcelRequire("9bmoE");
var $61e63582d122d3e9$require$key = $9bmoE.key;
module.exports = async (page)=>{
    const response2 = await fetch(`https://api.themoviedb.org/3/trending/movie/day?page=${page}&api_key=${$61e63582d122d3e9$require$key}`);
    const obj2 = await response2.json();
    const trendingList = obj2.results;
    // console.log(obj2.page);
    // console.log(obj2.total_pages);
    //console.log(obj2.total_results);
    return trendingList;
};

});
parcelRequire.register("9bmoE", function(module, exports) {
module.exports = {
    key: "8b218b85545392c9f8705c30fbfd1bce"
};

});


parcelRequire.register("c01Oz", function(module, exports) {

var $9bmoE = parcelRequire("9bmoE");
var $8bc6e47568c68f1d$require$key = $9bmoE.key;
// fetch(
//   `https://api.themoviedb.org/3/genre/movie/list?language=en&api_key=${key}`
// )
//   .then(res => res.json())
//   .then(res => console.log(res.genres));
module.exports = async ()=>{
    const res = await fetch(`https://api.themoviedb.org/3/genre/movie/list?language=en&api_key=${$8bc6e47568c68f1d$require$key}`);
    const genreObj = await res.json();
    return genreObj.genres; //returneaza o lista
};

});

parcelRequire.register("hAdDP", function(module, exports) {

var $c01Oz = parcelRequire("c01Oz");

var $25io1 = parcelRequire("25io1");

var $9HIXY = parcelRequire("9HIXY");
module.exports = async (movie)=>{
    const modal = document.querySelector(".modal-wrapper");
    const closeModalBtn = document.querySelector(".backdrop");
    toggleModal();
    closeModalBtn.addEventListener("click", ()=>{
        modal.classList.add("is-hidden");
    });
    function toggleModal() {
        modal.classList.toggle("is-hidden");
    }
    const voteCount = document.getElementById("voteCount");
    const popul = document.getElementById("popul");
    const origTitle = document.getElementById("origTitle");
    const about = document.getElementById("about");
    const image = document.getElementById("img");
    const voteRating = document.getElementById("voteRating");
    const filmTitle = document.getElementById("film-title");
    //
    const gen = document.getElementById("genre");
    let genreList = await $c01Oz();
    let genreIds = movie.genre_ids;
    gen.innerHTML = createGenreString(genreList, genreIds);
    //
    voteRating.innerHTML = movie.vote_average;
    voteCount.innerHTML = movie.vote_count;
    popul.innerHTML = movie.popularity;
    origTitle.innerHTML = movie.original_title;
    about.innerHTML = movie.overview;
    image.src = `https://image.tmdb.org/t/p/w500${movie.poster_path}`;
    filmTitle.innerHTML = movie.title;
    // console.log(filmTitle);
    // console.log(movie.title);
    function createGenreString(genreList, genreIds) {
        // o sa imi fac o lista de stringuri facand match din genre id cu genre list
        // console.log('----------------');
        // console.log(genreList);
        // console.log(genreIds);
        // console.log('----------------');
        let genreStrings = "";
        let ok = false;
        for(let i = 0; i < genreIds.length; i++){
            ok = false;
            for(let j = 0; j < genreList.length && ok === false; j++)if (genreIds[i] === genreList[j].id) {
                genreStrings += genreList[j].name;
                genreStrings += ", ";
                ok = true;
            }
        }
        let n = genreStrings.length;
        genreStrings = genreStrings.slice(0, n - 2);
        return genreStrings;
    }
    (()=>{
        const watBtn = document.querySelector(".add-to-watched-btn");
        const queBtn = document.querySelector(".add-to-queue-btn");
        //console.log(watBtn);
        watBtn.id = `watch${movie.id}`;
        queBtn.id = `queue${movie.id}`;
        //am targetat butoanele, mai departe vreau sa verific daca filmul curent este sau nu adaugat in coada sau watched
        //daca nu se afla, le las asa
        //daca se afla deja in vreo lista, vreau sa adaug clasa added butoanelor targetate
        let watList = $9HIXY.watched.map((e)=>e);
        let queList = $9HIXY.queue.map((e)=>e);
        if (checkMovie(watList, movie)) {
            watBtn.classList.add("added");
            watBtn.innerHTML = "ADDED TO WATCHED";
        } else {
            watBtn.classList.remove("added");
            watBtn.innerHTML = "ADD TO WATCHED";
        }
        if (checkMovie(queList, movie)) {
            queBtn.classList.add("added");
            queBtn.innerHTML = "ADDED TO QUEUE";
        } else {
            queBtn.classList.remove("added");
            queBtn.innerHTML = "ADD TO QUEUE";
        }
    })();
    $25io1(movie);
    function checkMovie(movieList, movie) {
        for(let i = 0; i < movieList.length; i++)if (movieList[i].id === movie.id) return true;
        return false;
    }
};

});
parcelRequire.register("25io1", function(module, exports) {

module.exports = (movie)=>{
    //aici vreau sa fac logica pt butoane, ca sa nu aglomerez fisierul js de modal
    //aici adaug event listener pentru butoanele de watched si queue
    //ma voi folosi de obiectul wat-que creat intr-un fisier js separat, ca la click pe oricare buton, sa se aplice modificarea corecta asupra obiectului
    const watQueObj = (parcelRequire("9HIXY"));
    // functia pe care o fac stiu sigur ca va fi chemata doar din modal
    // movie este obiectul din modal in momentul clickului
    const watched = document.querySelector(".add-to-watched-btn");
    const queue = document.querySelector(".add-to-queue-btn");
    let watchList = watQueObj.watched.map((e)=>e);
    let queueList = watQueObj.queue.map((e)=>e);
    watched.addEventListener("click", (e)=>{
        //console.log(e.target);
        let ok = check(watchList, movie);
        if (watched.id === e.target.id && !ok) {
            watchList.push(movie);
            // console.log(movie);
            watQueObj.watched = watchList;
            watched.classList.add("added");
            watched.innerHTML = "ADDED TO WATCHED";
        } else if (watched.id === e.target.id && ok) {
            //watchList.push(movie);
            const index = watchList.indexOf(movie);
            if (index > -1) //mereu ar trb sa fie mai mare
            watchList.splice(index, 1);
            watQueObj.watched = watchList;
            watched.classList.remove("added");
            watched.innerHTML = "ADD TO WATCHED";
        }
    });
    queue.addEventListener("click", (e)=>{
        // console.log(e.target);
        let ok = check(queueList, movie);
        if (queue.id === e.target.id && !ok) {
            queueList.push(movie);
            watQueObj.queue = queueList;
            queue.classList.add("added");
            queue.innerHTML = "ADDED TO QUEUE";
        } else if (queue.id === e.target.id && ok) {
            //watchList.push(movie);
            const index = queueList.indexOf(movie);
            if (index > -1) //mereu ar trb sa fie mai mare
            queueList.splice(index, 1);
            watQueObj.queue = queueList;
            queue.classList.remove("added");
            queue.innerHTML = "ADD TO QUEUE";
        }
    });
    function check(movieList, movie) {
        //verifica daca exista movie in movieList
        for(let i = 0; i < movieList.length; i++)if (movieList[i].id === movie.id) return true;
        return false;
    }
};

});
parcelRequire.register("9HIXY", function(module, exports) {
// aici voi face un obiect care va avea 2 atribute
// primul va fi watched si al doilea queue, ambele vor retine o lista de obiecte (filme)
//in module.exports exportez obiectul bazandu-ma pe faptul ca in JavaScript obiectele cand sunt transmise ca parametru
//in deosebire fata de valorile primitive, se transmite nu o copie a obiectului, ci adresa obiectului in sine
//asta inseamna ca orice modificare adusa obiectului pe parcursul proeictului, ea va fi salvata
// (sper)
const $710b028ef9ea1fcb$var$watQueObj = {
    watched: [],
    queue: []
};
//console.log(watQueObj);
module.exports = $710b028ef9ea1fcb$var$watQueObj;

});




parcelRequire.register("jwPrH", function(module, exports) {

var $hAdDP = parcelRequire("hAdDP");
module.exports = (movieList)=>{
    let movieContainer = document.querySelector(".movies__container");
    //   let numberContainer = document.querySelector('.number-wrapper');
    //   numberContainer.innerHTML = '';
    movieContainer.innerHTML = "";
    movieList.forEach((movie)=>{
        let htmlElement = createSmallMovieDiv(movie);
        htmlElement.addEventListener("click", (e)=>{
            $hAdDP(movie);
        });
        movieContainer.appendChild(htmlElement);
    });
    function createSmallMovieDiv(movie) {
        const smallDiv = document.createElement("div");
        smallDiv.classList.add("smallDiv");
        //creez titlul
        const title = document.createElement("p");
        title.classList.add("smallDiv__title");
        //
        let t = "";
        if (movie.title.length <= 25) t = movie.title;
        else {
            let elist = movie.title.split("");
            while(elist.length > 30)elist.pop();
            elist.push(".");
            elist.push(".");
            elist.push(".");
            t = elist.join("");
        }
        //
        title.innerHTML = `${t}`;
        smallDiv.appendChild(title);
        //creez imaginea
        const img = document.createElement("img");
        img.classList.add("smallDiv__image");
        img.src = `https://image.tmdb.org/t/p/w500${movie.poster_path}`;
        smallDiv.appendChild(img);
        //creez listuta
        const ul = document.createElement("ul");
        ul.classList.add("smallDiv__list");
        let li1 = document.createElement("li");
        li1.classList.add("smallDiv__list__element");
        let p1 = document.createElement("p");
        p1.classList.add("smallDiv__list__key");
        p1.innerHTML = "Rating";
        li1.appendChild(p1);
        let p2 = document.createElement("p");
        p2.classList.add("smallDiv__list__value");
        p2.innerHTML = `${movie.vote_average}`;
        li1.appendChild(p2);
        ul.appendChild(li1);
        let li2 = document.createElement("li");
        li2.classList.add("smallDiv__list__element");
        let p3 = document.createElement("p");
        p3.classList.add("smallDiv__list__key");
        p3.innerHTML = "Popularity";
        li2.appendChild(p3);
        let p4 = document.createElement("p");
        p4.classList.add("smallDiv__list__value");
        p4.innerHTML = `${movie.popularity}`;
        li2.appendChild(p4);
        ul.appendChild(li2);
        smallDiv.appendChild(ul);
        //creez descrierea
        let desc = movie.overview;
        desc = desc.split("");
        if (desc.length > 100) {
            desc = desc.slice(0, 100);
            desc.push("...");
        }
        desc = desc.join("");
        const overview = document.createElement("p");
        overview.innerHTML = desc;
        overview.classList.add("smallDiv__desc");
        smallDiv.appendChild(overview);
        return smallDiv;
    }
};

});

parcelRequire("9m8SW");
var $12d8f49abafd6c81$exports = {};

$12d8f49abafd6c81$exports = ()=>{
    const renderPages = (parcelRequire("9m8SW"));
    let currentPage = 1;
    const numbersDiv = document.querySelector(".numbers");
    let currentHtmlElement = document.getElementById(`${currentPage}`);
    const rightBtn = document.querySelector(".right");
    const leftBtn = document.querySelector(".left");
    addRed();
    window.addEventListener("DOMContentLoaded", function() {
        renderPages(currentPage);
        renderNumbers();
    });
    function renderNumbers() {
        numbersDiv.innerHTML = "";
        for(let i = currentPage - 2; i <= currentPage + 2 && i < 20; i++)if (i > 1 && i < 20) {
            let numberDiv = document.createElement("div");
            numberDiv.classList.add("number");
            numberDiv.innerHTML = `${i}`;
            numberDiv.setAttribute("id", `${i}`);
            numbersDiv.appendChild(numberDiv);
            numberDiv.addEventListener("click", ()=>{
                deleteRed();
                currentPage = numberDiv.id;
                currentHtmlElement = document.getElementById(`${currentPage}`);
                renderPages(currentPage);
                //numbersDiv.innerHTML = '';
                // console.log(currentPage);
                //renderNumbers();
                //console.log(renderNumbers);
                addRed();
            });
        }
    }
    function addRed() {
        currentHtmlElement.classList.add("current-page");
    }
    function deleteRed() {
        currentHtmlElement.classList.toggle("current-page");
    }
    //   function toggleCurrentPage() {
    //     currentHtmlElement.classList.toggle('current-page');
    //   }
    rightBtn.addEventListener("click", ()=>{
        if (currentPage < 20) {
            // console.log(currentPage);
            // console.log(currentHtmlElement);
            deleteRed();
            currentPage++;
            renderPages(currentPage);
            renderNumbers();
            currentHtmlElement = document.getElementById(`${currentPage}`);
            deleteRed();
        //console.log(currentPage);
        //console.log(currentHtmlElement);
        }
    });
    leftBtn.addEventListener("click", ()=>{
        if (currentPage > 1) {
            // console.log(currentPage);
            //console.log(currentHtmlElement);
            deleteRed();
            currentPage--;
            renderPages(currentPage);
            renderNumbers();
            currentHtmlElement = document.getElementById(`${currentPage}`);
            addRed();
        //console.log(currentPage);
        //console.log(currentHtmlElement);
        }
    });
    const first = document.getElementById("1");
    const last = document.getElementById("20");
    first.addEventListener("click", ()=>{
        deleteRed();
        currentPage = 1;
        renderPages(currentPage);
        renderNumbers();
        currentHtmlElement = document.getElementById(`${currentPage}`);
        addRed();
    });
    last.addEventListener("click", ()=>{
        deleteRed();
        currentPage = 20;
        renderPages(currentPage);
        renderNumbers();
        currentHtmlElement = document.getElementById(`${currentPage}`);
        addRed();
    });
};


var $1a3f199c55b37158$exports = {};

var $hAdDP = parcelRequire("hAdDP");
var $6f16bb81da006d4f$exports = {};




$6f16bb81da006d4f$exports = ()=>{
    const watQueObj = (parcelRequire("9HIXY"));
    const renderPage = (parcelRequire("9m8SW"));
    const renderList = (parcelRequire("jwPrH"));
    const watched = document.querySelector(".watched-button");
    const queue = document.querySelector(".queue-button");
    const home = document.querySelector(".home-button");
    watched.addEventListener("click", (e)=>{
        //console.log(watQueObj.watched);
        const watchList = watQueObj.watched.map((e)=>e);
        renderList(watchList);
    // const numberDiv = document.querySelector('.number-wrapper');
    // numberDiv.classList.add('is-hidden');
    });
    queue.addEventListener("click", (e)=>{
        //  console.log(watQueObj.queue);
        const queList = watQueObj.queue.map((e)=>e);
        renderList(queList);
    // const numberDiv = document.querySelector('.number-wrapper');
    // numberDiv.classList.add('is-hidden');
    });
    home.addEventListener("click", (e)=>{
        renderPage(1);
    // renderNumbers();
    // const numberDiv = document.querySelector('.number-wrapper');
    // numberDiv.classList.remove('is-hidden');
    });
};



$1a3f199c55b37158$exports = ()=>{
    const search = document.querySelector(".search-bar");
    let movieTitle;
    search.addEventListener("input", (e)=>{
        movieTitle = e.target.value;
    });
    //console.log(movieTitle);
    $6f16bb81da006d4f$exports();
    const searchBtn = document.querySelector(".search-button");
    searchBtn.addEventListener("click", (e)=>{
        const key = (parcelRequire("9bmoE")).key;
        const url = `https://api.themoviedb.org/3/search/movie?query=${movieTitle}&include_adult=false&language=en-US&page=1&api_key=${key}`;
        let movieObj;
        (async ()=>{
            const response = await fetch(url);
            const res = await response.json();
            movieObj = res.results[0];
            // console.log('------  Obiect Giulia  -----');
            //  console.log(movieObj);
            $hAdDP(movieObj);
        })();
    });
};


$1a3f199c55b37158$exports();
$12d8f49abafd6c81$exports(); //se apeleaza functia
 //renderPages(5);


//# sourceMappingURL=index.05f625c0.js.map
